// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { DFPManager } from 'react-dfp';
import styles from './styles';
import messages from './messages';

type Props = {
  visible: boolean,
  url: string,
  denyGdpr: Function,
  acceptGdpr: Function,
};

export default class GdprCookieBanner extends React.PureComponent<Props> {
  componentDidMount() {
    const { acceptGdpr } = this.props;
    acceptGdpr({ close: false });
  }

  onClickDeny = () => {
    this.alignGoogleAdsWithGdpr();
    const { denyGdpr } = this.props;
    denyGdpr();
  };

  onClickAccept = () => {
    const { acceptGdpr } = this.props;
    acceptGdpr({ close: true });
  };

  alignGoogleAdsWithGdpr = () => {
    DFPManager.configurePersonalizedAds(false);
    DFPManager.refresh();
  };

  render() {
    const { visible, url } = this.props;

    if (!visible) {
      return null;
    }

    return (
      <div className={'gdpr-cookie-banner'} data-test="gdpr-cookie-banner">
        <p>
          <FormattedMessage {...messages.gdprNotice} />
          <span>&nbsp;</span>
          <a href={url} target="_blank" className="link" rel="noopener noreferrer">
            <FormattedMessage {...messages.gdprInfo} />
          </a>
        </p>

        <div className="buttons-wrapper">
          <button type="button" onClick={this.onClickDeny} className="button" data-test="deny-gdpr">
            <FormattedMessage {...messages.gdprNo} />
          </button>
          <button
            type="button"
            onClick={this.onClickAccept}
            className="button"
            data-test="accept-gdpr"
          >
            <FormattedMessage {...messages.gdprYes} />
          </button>
        </div>

        <style jsx>{styles}</style>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Gdpr/components/mobile/GdprCookieBanner/component.js